import { Component } from '@angular/core';

import { BLOG_POSTS } from './blog-posts.generated';

@Component({
  selector: 'app-blog-index',
  templateUrl: './blog-index.component.html',
  styleUrls: ['./blog-index.component.scss']
})
export class BlogIndexComponent {

  // Generated newest first, with drafts already dropped at build time, so the listing
  // is a straight render of the manifest.
  readonly posts = BLOG_POSTS;

}
